module.exports = __webpack_public_path__ + "img/btn-comment.51a13a83.svg";